var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "800", persistent: "" },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { color: "primary", dark: "", flat: "" } },
            [
              _c("v-toolbar-title", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                { attrs: { icon: "" }, on: { click: _vm.close } },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pt-4" },
            [
              _c("div", { staticClass: "participants-header mb-0" }, [
                _vm._v(
                  "\n        Pontuados: " +
                    _vm._s(_vm.participants.length) +
                    " de " +
                    _vm._s(_vm.totalCount) +
                    " participantes\n      "
                ),
              ]),
              _vm._v(" "),
              _c("AppTable", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.participants,
                  loading: _vm.loading,
                  "hide-title": "",
                },
              }),
              _vm._v(" "),
              _c("AppPagination", {
                attrs: {
                  length: _vm.pageCount,
                  "current-pagination": _vm.currentPage,
                  loading: _vm.loading,
                },
                on: { onPagination: _vm.onPagination },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }